import { Injectable, OnDestroy } from '@angular/core'
import { concat, Observable, of, Subscription } from 'rxjs'

import backupAEMContent from '../AEM/aem-content.json'
import { AEMService } from '../AEM/aem-content.service'
@Injectable({
  providedIn: 'root',
})
export class CentralContentService implements OnDestroy {
  backUpContent$ = of(backupAEMContent)
  backUpContent: any
  aemContent$: Observable<any>
  aemContentLoaded: boolean
  aemContent: any
  backUPContentValue: string
  aemContentValue: string
  aemContentSub: Subscription

  constructor(private readonly aemService: AEMService) {}
  public load() {
    this.aemContent$ = concat(
      this.backUpContent$,
      this.aemService.getAEMContent(),
    )
    this.aemContentSub = this.aemContent$.subscribe(
      (params) => {
        this.aemContentLoaded = true
        this.aemContent = params
      },
      (error) => {
        this.aemContentLoaded = false
        console.log('The AEM Content was not pre-loaded')
        console.log(error)
      },
    )
  }
    //Used by components to parse out fragments from given body whether its the back-up file or actual aem content (always called in subscribes)
    getContentByBody(contentFragmentName: string, jsonBody: any): any {
      const contentValue = jsonBody.Data[`${contentFragmentName}`]?.content?.text
      if (contentValue) {
        return { contentValue: contentValue, isAEM: true }
      } else {
          return { contentValue: '', isAEM: false }
      }
    }
    //Used in cases where components will call only when AEM is finished loading
  getContent(contentFragmentName: string): any {
    this.backUpContent = backupAEMContent.Data
    this.backUPContentValue = this.backUpContent[
      `${contentFragmentName}`
    ]?.content?.text
    if (this.aemContentLoaded) {
      this.aemContentValue = this.aemContent.Data[
        `${contentFragmentName}`
      ]?.content?.text
      if (this.aemContentValue) {
        return {
          contentValue: this.aemContentValue,
          isAEM: this.aemContent.isAEM,
        }
      } else if (this.backUPContentValue) {
          return { contentValue: this.backUPContentValue, isAEM: false }
      } else {
          return { contentValue: '', isAEM: false }
      }
    } else {
        if (this.backUPContentValue) {
          return { contentValue: this.backUPContentValue, isAEM: false }
        } else {
          return { contentValue: '', isAEM: false }
        }
    }
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
